<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onSubmit)" v-loading="loadingDetail">
        <div class="section-header section-header--first">
            <div>
                <div class="section-title">I. Thông tin thi lại</div>
                <div class="section-subtitle">Chọn học viên, lịch thi và kỹ năng cần thi lại</div>
            </div>
        </div>

        <el-row :gutter="20" class="form-row">
            <el-col :span="12">
                <ValidationProvider v-slot="{ errors }" name="Học viên" rules="required" vid="student">
                    <div class="display-flex-column">
                        <label>Học viên <span style="color: red">*</span></label>
                        <el-select
                            ref="new_student"
                            v-model="form.user_id"
                            :disabled="lockRegistrationFields"
                            :loading="loading"
                            :remote-method="remoteMethod"
                            class="w-100"
                            clearable
                            filterable
                            placeholder="Nhập mã học viên, số điện thoại, tên học viên"
                            remote
                            reserve-keyword
                            @change="handleSelectUser"
                        >
                            <el-option
                                v-for="user in userSearch"
                                :key="user.id"
                                :label="user.id + 100000 + ' - ' + user.name"
                                :value="user.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </el-col>

            <el-col :span="12">
                <div class="display-flex-column">
                    <label>Khóa học</label>
                    <el-select
                        v-model="form.course_id"
                        :disabled="lockRegistrationFields"
                        clearable
                        filterable
                        placeholder="Chọn khóa học thi lại"
                        @change="handleSelectCourse">
                        <el-option
                            v-for="item in courses"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </div>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="form-row">
            <el-col :span="12">
                <div class="display-flex-column">
                    <label>Tên lớp</label>
                    <el-select v-model="form.classroom_id" :disabled="lockRegistrationFields" clearable filterable
                               placeholder="Chọn tên lớp">
                        <el-option
                            v-for="item in classrooms"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </div>
            </el-col>

            <el-col :span="12">
                <ValidationProvider v-slot="{ errors }" name="Ngày thi" rules="required" vid="time">
                    <div class="display-flex-column">
                        <label>Ngày thi <span style="color: red">*</span></label>
                        <el-select
                            v-model="form.exam_date"
                            clearable
                            filterable
                            placeholder="Chọn ngày thi"
                            @change="handleSelectExamDate">
                            <el-option
                                v-for="item in dateExamOption"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="form-row">
            <el-col :span="12">
                <ValidationProvider v-slot="{ errors }" name="Thời gian thi" rules="required" vid="timeExam">
                    <div class="display-flex-column">
                        <label>Thời gian thi <span style="color: red">*</span></label>
                        <el-select v-model="form.exam_time" clearable filterable
                                   placeholder="Chọn khoảng thời gian thi">
                            <el-option
                                v-for="item in timeOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </el-col>

            <el-col :span="12">
                <ValidationProvider v-slot="{ errors }" name="Kỹ năng thi lại" rules="required" vid="skill">
                    <div class="display-flex-column">
                        <label>Kỹ năng thi lại <span style="color: red">*</span></label>
                        <el-select v-model="form.skills" clearable filterable multiple
                                   placeholder="Chọn kỹ năng thi lại">
                            <el-option
                                v-for="item in skillOption"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="form-row">
            <el-col :span="12">
                <ValidationProvider v-slot="{ errors }" name="Lần thi lại" rules="required" vid="retest">
                    <div class="display-flex-column">
                        <label>Lần thi lại <span style="color: red">*</span></label>
                        <el-select v-model="form.retest_count" clearable filterable placeholder="Chọn lần thi lại">
                            <el-option
                                v-for="item in numberRetestOption"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </el-col>
        </el-row>

        <template v-if="lockPaymentSection">
            <el-alert
                :closable="false"
                class="mb-3"
                description="Chỉ được sửa ngày thi, thời gian thi, kỹ năng thi và lần thi. Thông tin thanh toán không thể thay đổi từ màn hình này."
                show-icon
                title="Khách hàng đã thanh toán hoặc đã xác nhận miễn phí"
                type="info"
            />
        </template>
        <template v-else>
            <div style="margin-top: 10px; margin-bottom: 6px">
                <h5 style="margin-bottom: 0">II. Thông tin thanh toán</h5>
      </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px">
                <ValidationProvider v-slot="{ errors }" name="Thanh toán phí thi lại" rules="required"
                                    vid="retest_fee_type">
                    <div class="display-flex-column">
                        <label>Thanh toán phí thi lại <span style="color: red">*</span></label>
                        <el-select
                            v-model="form.retest_fee_type"
                            :disabled="isPaymentLocked"
                            clearable
                            filterable
                            placeholder="Chọn học viên cần thanh toán phí/Không thanh toán phí"
                            @change="handleChangeFeeType"
                        >
                            <el-option
                                v-for="opt in retestFeeTypeOptions"
                                :key="opt.id"
                                :label="opt.name"
                                :value="opt.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    v-slot="{ errors }"
                    :rules="form.retest_fee_type === RETEST_FEE_TYPE.PAID ? 'required' : ''"
                    name="Số tiền cần thanh toán"
                    vid="payment_amount_option">
                    <div class="display-flex-column">
                        <label>Số tiền cần thanh toán <span style="color: red">*</span></label>
                        <el-select
                            v-model="form.payment_amount_option"
                            :disabled="isPaymentLocked || form.retest_fee_type === RETEST_FEE_TYPE.FREE"
                            clearable
                            filterable
                            placeholder="Chọn số tiền cần thanh toán"
                            @change="handleChangeAmountOption"
                        >
                            <el-option
                                v-for="opt in paymentAmountOptions"
                                :key="opt.id"
                                :label="opt.name"
                                :value="opt.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </div>

            <div
                v-if="form.retest_fee_type === RETEST_FEE_TYPE.PAID && form.payment_amount_option === PAYMENT_AMOUNT_OPTION.OTHER"
                style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px">
                <ValidationProvider v-slot="{ errors }" name="Số tiền khác" rules="required"
                                    vid="payment_amount_other">
                    <div class="display-flex-column">
                        <label>Số tiền khác <span style="color: red">*</span></label>
                        <el-input
                            v-model.number="form.payment_amount_other"
                            :disabled="isPaymentLocked"
                            placeholder="Nhập số tiền"
                            type="number"
                            @input="handleInputOtherAmount"
                        />
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
                <ValidationProvider
                    v-slot="{ errors }"
                    :rules="form.retest_fee_type === RETEST_FEE_TYPE.PAID ? 'required' : ''"
                    name="Hình thức thanh toán"
                    vid="payment_method_other_row">
                    <div class="display-flex-column">
                        <label>Hình thức thanh toán <span style="color: red">*</span></label>
                        <el-select
                            v-model="form.payment_method"
                            :disabled="isPaymentLocked || form.retest_fee_type === RETEST_FEE_TYPE.FREE"
                            clearable
                            filterable
                            placeholder="Chọn hình thức thanh toán phí thi lại"
                        >
                            <el-option
                                v-for="opt in paymentMethodOptions"
                                :key="opt.id"
                                :label="opt.name"
                                :value="opt.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
            </div>

            <div
                v-else
                style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 10px">
                <ValidationProvider
                    v-slot="{ errors }"
                    :rules="form.retest_fee_type === RETEST_FEE_TYPE.PAID ? 'required' : ''"
                    name="Hình thức thanh toán"
                    vid="payment_method">
                    <div class="display-flex-column">
                        <label>Hình thức thanh toán <span style="color: red">*</span></label>
                        <el-select
                            v-model="form.payment_method"
                            :disabled="isPaymentLocked || form.retest_fee_type === RETEST_FEE_TYPE.FREE"
                            clearable
                            filterable
                            placeholder="Chọn hình thức thanh toán phí thi lại"
                        >
                            <el-option
                                v-for="opt in paymentMethodOptions"
                                :key="opt.id"
                                :label="opt.name"
                                :value="opt.id"
                            />
                        </el-select>
                    </div>
                    <div class="fv-plugins-message-container">
                        <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{ errors[0] }}</div>
                    </div>
                </ValidationProvider>
                <div></div>
            </div>
        </template>

        <div style="display: flex;justify-content: flex-end; gap: 5px; margin-top: 20px">
            <el-button class="button-cancel" @click="closeDialog">{{ isEditMode ? 'Huỷ bỏ' : 'Đóng' }}</el-button>
        <button
            v-loading="isBusy"
            type="submit"
            style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px"
            :disabled="isBusy">
          Xác nhận
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {numberRetestOption} from "@/common/define";
import {SEARCH_CUSTOMER_BY_OR_ID} from "@/core/services/store/user/users.module";
import {
    CREATE_RETEST,
    GET_ALL_EXAM_SCHEDULE,
    GET_CLASS_ACTIVE_BY_USER,
    GET_COURSES_ACTIVE_BY_USER,
    GET_DETAILS_RETEST,
    GET_SKILLS_RETEST,
    UPDATE_RETEST
} from "@/core/services/store/examSchedule/examSchedule";
import moment from "moment-timezone";
import {RETEST_PAYMENT_FILTER, RetestModel} from "../model/RetestModel";

const RETEST_FEE_TYPE = Object.freeze({
    FREE: 0,
    PAID: 1,
})

const PAYMENT_AMOUNT_OPTION = Object.freeze({
    REQUEST: 100000,
    CHEATING: 300000,
    OTHER: -1,
})

const PAYMENT_METHOD = Object.freeze({
    BANK_TRANSFER: 'transfer',
    CASH: 'cash',
    CARD: 'card',
})

export default {
  name: 'FormRetest',
  props: {
    scheduleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loadingDetail: false,
      isBusy: false,
      loading: false,
      retestDetail: {},
      courses: [],
      classrooms: [],
      form: {
        user: null,
        user_id: null,
        classroom_id: null,
        course_id: null,
        exam_date: null,
        exam_time: null,
        retest_count: null,
        skills: [],
          retest_fee_type: null,
          payment_amount_option: null,
          payment_amount: null,
          payment_amount_other: null,
          payment_method: null,
      },
      userSearch: [],
      numberRetestOption,
      skillOption: [],
      dateExamOption: [],
      timeExamOption: [],
        timeOptions: [],
        RETEST_FEE_TYPE,
        PAYMENT_AMOUNT_OPTION,
        /** Snapshot thanh toán lúc load chi tiết: so sánh khi update chưa TT để quyết định có gửi key thanh toán hay không */
        originalPaymentSnapshot: null,
        retestFeeTypeOptions: [
            {id: RETEST_FEE_TYPE.FREE, name: 'Miễn phí'},
            {id: RETEST_FEE_TYPE.PAID, name: 'Mất phí'},
        ],
        paymentAmountOptions: [
            {id: PAYMENT_AMOUNT_OPTION.REQUEST, name: '100.000 đ - Học viên thi lại theo yêu cầu', amount: 100000},
            {id: PAYMENT_AMOUNT_OPTION.CHEATING, name: '300.000 đ - Học viên gian lận cần thi lại', amount: 300000},
        ],
        paymentMethodOptions: [
            {id: PAYMENT_METHOD.BANK_TRANSFER, name: 'Chuyển khoản'},
            {id: PAYMENT_METHOD.CASH, name: 'Tiền mặt'},
            {id: PAYMENT_METHOD.CARD, name: 'Quẹt thẻ'},
        ],
    }
  },
  async mounted() {
    if (this.scheduleId) {
      await this.getDetailRetest()
    }
    await this.getAllExamSchedule()
  },
    computed: {
        isEditMode() {
            return !!this.scheduleId
        },
        /** Đã TT hoặc miễn phí đã xác nhận: ẩn và không gửi thay đổi phần thanh toán */
        lockPaymentSection() {
            if (!this.isEditMode) return false
            const raw = this.retestDetail?.data ?? this.retestDetail
            if (!raw || typeof raw !== 'object') return false
            const cat = RetestModel.resolvePaymentCategory(raw)
            return cat === RETEST_PAYMENT_FILTER.PAID || cat === RETEST_PAYMENT_FILTER.FREE
        },
        lockRegistrationFields() {
            return this.lockPaymentSection
        },
        /** Giữ tên cũ cho các chỗ disable từng field trong block thanh toán (khi vẫn hiện form) */
        isPaymentLocked() {
            return this.lockPaymentSection
        },
    },
  methods: {
    remoteMethod: function (query) {
      if (query !== "") {
        const params = {
          search_customer_by_phoneOrId: query,
          limit: 10000,
          status: 1,
          is_staff: 0,
        }
        this.loading = true;
        let vm = this;
        setTimeout(function () {
          vm.getStudents(params);
        }, 300)
      }
    },
    getStudents(params) {
      this.$store.dispatch(SEARCH_CUSTOMER_BY_OR_ID, params).then((res) => {
        this.userSearch = res.data.data;
        this.loading = false;
      })
    },
    async handleSelectCourse() {
      if (this.form.course_id) {
        await this.getSkillsExam(this.form.course_id)
      }
    },

    async handleSelectUser() {
      const userId = this.form.user_id
      if (userId) {
        this.resetFormStore(userId)
        await Promise.all([
          this.getCourseActiveUser(userId),
          this.getClassActiveUser(userId)
        ])
      }
    },
    async getSkillsExam(courseId) {
      try {
        const res = await this.$store.dispatch(GET_SKILLS_RETEST, {course_id: courseId})
        if (!res.error) {
          this.skillOption = res.data
        }
      } catch (err) {
        console.error("Error fetching skills:", err)
      }
    },
    closeDialog() {
      this.$emit('closeDialog');
      this.isBusy = false
      this.resetForm()
    },
    async getCourseActiveUser(userId) {
      try {
        await this.$store.dispatch(GET_COURSES_ACTIVE_BY_USER, {user_id: userId}).then(res => {
          if (!res.error) {
            this.courses = res.data
          }
        })
      } catch (err) {
        console.error("Error fetching courses by user:", err)
      }
    },

    async getClassActiveUser(userId) {
      try {
        this.$store.dispatch(GET_CLASS_ACTIVE_BY_USER, {user_id: userId}).then(res => {
          if (!res.error) {
            this.classrooms = res.data
          }
        })
      } catch (err) {
        console.error("Error fetching classrooms by user:", err)
      }
    },
    handleSelectExamDate() {
      this.form.exam_time = null
      const currentExamDay = this.dateExamOption.find(item => item.id === this.form.exam_date)
      this.timeOptions = (currentExamDay?.marking_exam_shifts ?? [])
          // 1) chỉ lấy những shift chưa full
          .filter(shift => (shift.registration_count ?? 0) < (shift.max_slot ?? Infinity))
          // 2) gom theo exam_time, giữ thằng registration_count lớn nhất
          .reduce((map, shift) => {
            const key = shift.exam_time; // tiêu chí trùng
            const current = map.get(key);

            const curCount = current?.registration_count ?? -1;
            const nextCount = shift.registration_count ?? 0;

            if (!current || nextCount > curCount) {
              map.set(key, shift);
            }
            return map;
          }, new Map())
          // 3) convert sang option
          .values();

      this.timeOptions = Array.from(this.timeOptions).map(shift => ({
        id: shift.id,
        name: this.formatTime(shift?.start_time, shift?.end_time),
      }));
    },
    getDateExam(data) {
      this.dateExamOption = data.map(item => ({
        id: item.id,
        name: this.formatDate(item.exam_date),
        marking_exam_shifts:item.marking_exam_shifts
      })) ?? []
    },
    getTimeExam(data) {
      // this.timeExamOption = data.map(item => ({
      //   id: item.id,
      //   name: this.formatTime(item.start_time, item.end_time)
      // })) ?? []
      // if (this.scheduleId) {
      //   this.timeOptions = this.timeExamOption.filter(item => item.id === this.form.exam_date)
      // }
    },
    async getAllExamSchedule() {
      try {
        const res = await this.$store.dispatch(GET_ALL_EXAM_SCHEDULE)
        if (!res.error) {
          let data = res.data
          if (this.scheduleId) {
            const sameId = data.find(item => item.id === this.retestDetail?.marking_exam_schedule?.id)
            if (!sameId) {
              data.push(this.retestDetail.marking_exam_schedule)
            }
          }
          this.getDateExam(data)
          this.getTimeExam(data)
        }
      } catch (err) {
        console.error("Error fetching exam schedule:", err)
      } finally {
        this.loadingDetail = false
      }
    },
      /** Lấy body chi tiết; backend có thể bọc `{ data: { retake, payment } }`. */
      unwrapRetestDetailResponse(res) {
          let payload = res?.data !== undefined ? res.data : res
          if (payload && typeof payload === 'object' && payload.retake == null && payload.data?.retake != null) {
              payload = payload.data
          }
          return payload
      },
      /**
       * Gộp `{ retake, payment }` thành một object phẳng để bind form và `resolvePaymentCategory`.
       */
      mergeRetestDetailPayload(raw) {
          if (!raw || typeof raw !== 'object') return raw
          if (raw.retake != null) {
              const r = raw.retake
              const p = raw.payment != null && typeof raw.payment === 'object' ? raw.payment : {}
              return {
                  ...r,
                  payment: Object.keys(p).length ? p : (r.payment ?? {}),
                  retest_fee_type: r.retest_fee_type ?? r.payment_fee_type ?? p.retest_fee_type,
                  payment_fee_type: r.payment_fee_type ?? p.payment_fee_type,
                  payment_amount: r.payment_amount ?? p.payment_amount ?? (p.amount != null ? p.amount : null),
                  payment_amount_option: r.payment_amount_option ?? p.payment_amount_option,
                  payment_amount_other: r.payment_amount_other ?? p.payment_amount_other,
                  payment_method: r.payment_method ?? p.payment_method ?? p.method,
                  payment_status: r.payment_status ?? p.payment_status,
                  paid_at: r.paid_at ?? p.paid_at,
                  marking_exam_schedule: r.marking_exam_schedule ?? r.markingExamSchedule,
                  marking_exam_shift: r.marking_exam_shift ?? r.markingExamShift,
              }
          }
          const p = raw.payment != null && typeof raw.payment === 'object' ? raw.payment : null
          if (p && (raw.payment_amount == null || raw.retest_fee_type == null || raw.payment_method == null)) {
              return {
                  ...raw,
                  retest_fee_type: raw.retest_fee_type ?? raw.payment_fee_type ?? p.retest_fee_type,
                  payment_amount: raw.payment_amount ?? p.payment_amount ?? (p.amount != null ? p.amount : null),
                  payment_amount_option: raw.payment_amount_option ?? p.payment_amount_option,
                  payment_amount_other: raw.payment_amount_other ?? p.payment_amount_other,
                  payment_method: raw.payment_method ?? p.payment_method ?? p.method,
                  payment_status: raw.payment_status ?? p.payment_status,
                  paid_at: raw.paid_at ?? p.paid_at,
              }
          }
          return raw
      },
      normalizePaymentMethodFromApi(m) {
          if (m == null || m === '') return null
          if (typeof m === 'number') {
              if (m === 1) return PAYMENT_METHOD.BANK_TRANSFER
              if (m === 2) return PAYMENT_METHOD.CASH
              if (m === 3) return PAYMENT_METHOD.CARD
          }
          const s = String(m).toLowerCase().trim()
          if (s === 'transfer' || s === 'bank_transfer') return PAYMENT_METHOD.BANK_TRANSFER
          if (s === 'cash') return PAYMENT_METHOD.CASH
          if (s === 'card') return PAYMENT_METHOD.CARD
          if (s.includes('chuyển') || s.includes('chuyen')) return PAYMENT_METHOD.BANK_TRANSFER
          if (s.includes('mặt') || (s.includes('tien') && s.includes('mat'))) return PAYMENT_METHOD.CASH
          if (s.includes('thẻ') || s.includes('quet')) return PAYMENT_METHOD.CARD
          return m
      },
    async getDetailRetest() {
      this.loadingDetail = true
      try {
        const res = await this.$store.dispatch(GET_DETAILS_RETEST, {id: this.scheduleId})
        if (!res.error) {
            const payload = this.unwrapRetestDetailResponse(res)
            const data = this.mergeRetestDetailPayload(payload)
          this.retestDetail = data
            const scheduleId =
                data.marking_exam_schedule_id ??
                data.marking_exam_schedule?.id ??
                data.markingExamSchedule?.id ??
                null
            const shiftId =
                data.marking_exam_shift_id ??
                data.marking_exam_shift?.id ??
                data.marking_exam_schedule_shift_id ??
                data.markingExamShift?.id ??
                null
          this.form = {
              user_id: data.user_id ?? data.user?.id ?? null,
            classroom_id: data.classroom_id,
            course_id: data.course_id,
              exam_date: scheduleId,
              exam_time: shiftId ?? scheduleId,
            retest_count: data.retest_count ? +data.retest_count : null,
            skills: data.skills ?? [],
              retest_fee_type: data.retest_fee_type ?? data.payment_fee_type ?? null,
              payment_amount_option: data.payment_amount_option ?? null,
              payment_amount:
                  data.payment_amount != null && data.payment_amount !== ''
                      ? +data.payment_amount
                      : data.payment?.payment_amount != null
                          ? +data.payment.payment_amount
                          : null,
              payment_amount_other:
                  data.payment_amount_other != null && data.payment_amount_other !== ''
                      ? +data.payment_amount_other
                      : null,
              payment_method:
                  data.payment_method ??
                  data.payment?.payment_method ??
                  data.payment?.method ??
                  null,
          }
            if (data.user?.id != null) {
                this.userSearch = [{id: data.user.id, name: data.user.name}]
            }
            this.normalizePaymentFromDetail()
            this.originalPaymentSnapshot = {...this.paymentPayloadFromForm()}
          await this.getSkillsExam(data.course_id)
            await this.getCourseActiveUser(data.user_id ?? data.user?.id)
            await this.getClassActiveUser(data.user_id ?? data.user?.id)
            await this.$nextTick()
            if (this.form.exam_date) {
                const keepShift = this.form.exam_time
                this.handleSelectExamDate()
                if (keepShift) this.form.exam_time = keepShift
            }
        }
      } catch (error) {
        console.error("Error fetching retest detail:", error)
      }
    },
    resetForm() {
      const record = this.retestDetail
      this.form = record ? {
        user_id: `${record.user?.id + 100000} - ${record.user?.name}`,
        classroom_id: record.classroom_id,
        course_id: record.course_id,
        exam_date: record.exam_date,
        exam_time: record.exam_time,
        retest_count: record.retest_count,
        skills: record.skills ?? [],
      } : this.resetFormStore
    },
    resetFormStore(userId) {
      this.form = {
        user_id: userId,
        classroom_id: null,
        course_id: null,
        exam_date: null,
        exam_time: null,
        retest_count: null,
        skills: [],
          retest_fee_type: null,
          payment_amount_option: null,
          payment_amount: null,
          payment_amount_other: null,
          payment_method: null,
      }
    },
      normalizePaymentFromDetail() {
          // Nếu backend trả về amount mà chưa có option, cố gắng map
          if (this.form.retest_fee_type === RETEST_FEE_TYPE.FREE) {
              this.form.payment_amount_option = null
              this.form.payment_amount = 0
              this.form.payment_amount_other = null
              this.form.payment_method = null
              return
      }

          if (this.form.payment_amount_option != null && this.form.payment_amount_option !== '') {
              const po = +this.form.payment_amount_option
              if (!Number.isNaN(po)) {
                  if (po === PAYMENT_AMOUNT_OPTION.REQUEST) this.form.payment_amount_option = PAYMENT_AMOUNT_OPTION.REQUEST
                  else if (po === PAYMENT_AMOUNT_OPTION.CHEATING) this.form.payment_amount_option = PAYMENT_AMOUNT_OPTION.CHEATING
                  else if (po === PAYMENT_AMOUNT_OPTION.OTHER) this.form.payment_amount_option = PAYMENT_AMOUNT_OPTION.OTHER
              }
          }

          if (this.form.payment_amount_option == null && this.form.payment_amount != null) {
              const amount = +this.form.payment_amount
              if (amount === 100000) this.form.payment_amount_option = PAYMENT_AMOUNT_OPTION.REQUEST
              else if (amount === 300000) this.form.payment_amount_option = PAYMENT_AMOUNT_OPTION.CHEATING
              else if (amount > 0) {
                  this.form.payment_amount_option = PAYMENT_AMOUNT_OPTION.OTHER
                  this.form.payment_amount_other = amount
              }
          }

          if (this.form.payment_amount_option === PAYMENT_AMOUNT_OPTION.REQUEST) this.form.payment_amount = 100000
          if (this.form.payment_amount_option === PAYMENT_AMOUNT_OPTION.CHEATING) this.form.payment_amount = 300000
          if (this.form.payment_amount_option === PAYMENT_AMOUNT_OPTION.OTHER) this.form.payment_amount = +this.form.payment_amount_other || null
          this.form.payment_method = this.normalizePaymentMethodFromApi(this.form.payment_method)
      },
      handleChangeFeeType() {
          if (this.form.retest_fee_type === RETEST_FEE_TYPE.FREE) {
              this.form.payment_amount_option = null
              this.form.payment_amount = 0
              this.form.payment_amount_other = null
              this.form.payment_method = null
              return
          }
          // PAID
          this.form.payment_amount = null
      },
      handleChangeAmountOption() {
          const opt = this.paymentAmountOptions.find(o => o.id === this.form.payment_amount_option)
          if (!opt) return

          if (opt.id === PAYMENT_AMOUNT_OPTION.OTHER) {
              this.form.payment_amount = +this.form.payment_amount_other || null
              return
          }

          this.form.payment_amount_other = null
          this.form.payment_amount = opt.amount
          if (!this.form.payment_method) this.form.payment_method = PAYMENT_METHOD.BANK_TRANSFER
      },
      handleInputOtherAmount() {
          if (this.form.payment_amount_option === PAYMENT_AMOUNT_OPTION.OTHER) {
              const v = this.form.payment_amount_other
              this.form.payment_amount = v != null && v !== '' ? +v : null
              if (!this.form.payment_method) this.form.payment_method = PAYMENT_METHOD.BANK_TRANSFER
          }
      },
      /** Payload các key thanh toán (dùng cho POST tạo mới hoặc PUT khi có thay đổi thanh toán). */
      paymentPayloadFromForm() {
          const f = this.form
          return {
              retest_fee_type: f.retest_fee_type,
              payment_amount_option: f.payment_amount_option,
              payment_amount: f.retest_fee_type === RETEST_FEE_TYPE.FREE ? 0 : f.payment_amount,
              payment_amount_other:
                  f.retest_fee_type === RETEST_FEE_TYPE.PAID &&
                  f.payment_amount_option === PAYMENT_AMOUNT_OPTION.OTHER
                      ? f.payment_amount_other
                      : null,
              payment_method: f.retest_fee_type === RETEST_FEE_TYPE.FREE ? null : f.payment_method,
          }
      },
      normalizePaymentFieldValue(v) {
          if (v === '' || v === undefined) return null
          if (typeof v === 'number' && Number.isNaN(v)) return null
          return v
      },
      paymentsEqualForPayload(a, b) {
          if (!a || !b) return false
          const keys = [
              'retest_fee_type',
              'payment_amount_option',
              'payment_amount',
              'payment_amount_other',
              'payment_method',
          ]
          return keys.every(
              (k) => this.normalizePaymentFieldValue(a[k]) === this.normalizePaymentFieldValue(b[k]),
          )
    },
    async onSubmit() {
      this.isBusy = true
        const basePayload = {
            ...(this.scheduleId ? {id: this.scheduleId} : {}),
        user_id: this.retestDetail.user_id ? this.retestDetail.user_id : this.form.user_id,
        classroom_id: this.form.classroom_id,
        course_id: this.form.course_id,
        marking_exam_shift_id: this.form.exam_time,
        retest_count: this.form.retest_count,
        skills: this.form.skills ?? [],
      }

        let payload
        if (!this.scheduleId) {
            payload = {...basePayload, ...this.paymentPayloadFromForm()}
        } else if (this.lockPaymentSection) {
            payload = basePayload
        } else if (
            this.originalPaymentSnapshot &&
            this.paymentsEqualForPayload(this.originalPaymentSnapshot, this.paymentPayloadFromForm())
        ) {
            payload = basePayload
        } else {
            payload = {...basePayload, ...this.paymentPayloadFromForm()}
        }

      const action = this.scheduleId ? UPDATE_RETEST : CREATE_RETEST

      try {
        const res = await this.$store.dispatch(action, payload)
        if (!res.error) {
          this.$emit('getListRetest')
          this.closeDialog()
            this.$message.success(this.scheduleId ? 'Cập nhật lịch thi lại thành công' : 'Tạo mới thành công')
        }
      } catch (err) {
        console.log(err)
        this.$message.error(err?.data?.message || 'Có lỗi xảy ra')
      } finally {
        this.isBusy = false
      }
    },
    formatDate(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY');
      }
      return ''
    },
    formatTime(start, end) {
      if (start && end) {
        return `${start} - ${end}`;
      }
      return ``
    },
  }
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.retest-divider {
    margin: 16px 0;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
}

.section-header--first {
    margin-bottom: 12px;
}

.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
}

.section-subtitle {
    margin-top: 2px;
    font-size: 12px;
    color: #6B7280;
}

.form-row {
    margin-bottom: 10px;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
}

.button-submit {
    background: #5E00B6;
    color: white;
    padding: 10px 16px;
    border-radius: 6px;
    border: none;
    font-weight: 600;
}

.button-submit[disabled] {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
